<app-menu #appMenu></app-menu>

<div class="shopping-cart-container">
  <div class="container">
    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <ng-container *ngIf="cart && cart.listShoppingCart.length > 0; else emptyCartTemplate">

        <div class="cart-header">
          <h1>Meu carrinho</h1>
        </div>

        <div class="cart-layout">
          <div class="cart-items-column">
            <app-shopping-cart-item *ngFor="let item of cart.listShoppingCart" [item]="item"
              (quantityChanged)="handleQuantityChanged($event)">
            </app-shopping-cart-item>
          </div>

          <div class="cart-summary-column">
            <div class="sticky-summary">
              <div class="summary-header">
                <h2>Resumo do Pedido</h2>
              </div>

              <div class="summary-totals">
                <div class="summary-updating" *ngIf="isUpdating">
                  <mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner>
                  <span>Atualizando carrinho...</span>
                </div>
                <div class="summary-row">
                  <span>Subtotal ({{ cart.listShoppingCart.length }} produtos)</span>
                  <span>{{ subtotal | currency:'BRL' }}</span>
                </div>
                <div class="summary-row">
                  <span>Frete</span>
                  <span>{{ selectedShippingCost > 0 ? (selectedShippingCost | currency:'BRL') : 'A calcular' }}</span>
                </div>
                <div class="summary-row total">
                  <span class="gren">Total</span>
                  <strong class="gren">{{ grandTotal | currency:'BRL' }}</strong>
                </div>
              </div>

              <div class="shipping-section">
                <mat-form-field appearance="outline">
                  <mat-label>CEP</mat-label>
                  <input matInput [(ngModel)]="cep" mask="00000-000" placeholder="00000-000">
                </mat-form-field>
                <button mat-stroked-button (click)="calculateShipping()">Calcular</button>



                <div *ngIf="cart != undefined && cart.listCorreios?.length">
                  <mat-radio-group [(ngModel)]="selectedShipping">
                    <mat-radio-button *ngFor="let option of cart.listCorreios" [value]="option.serviceCode"
                      [disabled]="option.isDisabledDueToWeight">
                      <span>{{ option.serviceName }}</span>
                      <span *ngIf="!option.isDisabledDueToWeight">{{ option.price | currency:'BRL' }}</span>
                      <span *ngIf="option.isDisabledDueToWeight" class="shipping-weight-warning">
                        — Indisponível: o peso do pedido ({{ option.weightKg | number:'1.2-2' }}kg) excede o limite de {{ option.weightLimitKg }}kg desta modalidade
                      </span>
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>

              <div class="buy-button-container">
                <button mat-flat-button class="buy-now-btn btn-primary" (click)="goToCheckout()">Comprar
                  agora</button>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
    </ng-container>

    <ng-template #loadingTemplate>
      <div class="loading-spinner">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
    </ng-template>

    <ng-template #emptyCartTemplate>
      <app-empty-list title="Seu carrinho está vazio" subTitle="Adicione livros ao seu carrinho para vê-los aqui.">
      </app-empty-list>
      <div class="continue-shopping">
        <button mat-flat-button class="btn-primary" (click)="continueShopping()">Continuar comprando</button>
      </div>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>